import React, { useState, useEffect } from "react";
import "./Hero.css";

// ✅ Import images
import masjid1 from "../assets/IMG_20250407_185631.jpg";
import masjid2 from "../assets/IMG_20250407_185646.jpg";
import masjid3 from "../assets/IMG_20250407_185703.jpg";

const slides = [
  {
    image: masjid1,
    title: "Welcome to Kanaipur Farukiya Masjid",
    text: "A peaceful place for daily prayers, spiritual growth, and devotion."
  },
  {
    image: masjid2,
    title: "A Center of Islamic Learning",
    text: "Teaching the Qur’an, Sunnah, and Islamic values for all ages."
  },
  {
    image: masjid3,
    title: "Serving the Community",
    text: "Strengthening unity through worship, charity, and community programs."
  }
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="hero"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${slides[current].image})`
      }}
    >
      <div className="hero-content">
        <h1>{slides[current].title}</h1>
        <p>{slides[current].text}</p>
      </div>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={current === index ? "dot active" : "dot"}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </section>
  );
}
